// define times in UTC
export const IDENTITY_MANDATORY_MODAL_DATE = '2026-01-13T17:00:00Z'; // 9AM PST

export const ROLLOUT_BATCHES = {
  Y_2025_ALL: '1',
  Y_2024_NO_SYNC: '2',
  // batch 3, 4, 5 are legacy only
  BEFORE_2024_NO_SYNC: '6',
  H2_2024_ALL: '7',
  H1_2024_ALL: '7',
  Y_2023_ALL: '9',
  Y_2022_ALL: '9',
  BEFORE_2022_ALL: '11',
  FINAL: '11',
} as const;

export type RolloutBatch =
  (typeof ROLLOUT_BATCHES)[keyof typeof ROLLOUT_BATCHES];

export const BATCH_RELEASE_DATE_MAP = {
  '1': new Date('2025-09-04T17:00:00Z'), // 10AM PDT
  '2': new Date('2025-09-11T17:00:00Z'),
  '6': new Date('2025-10-01T17:00:00Z'),
  '7': new Date('2025-10-06T17:00:00Z'),
  // original batch 8 is now combined into 7
  '9': new Date('2025-10-21T17:00:00Z'),
  // original batch 10 is now combined into 9
  '11': new Date('2025-10-27T17:00:00Z'),
};
